import Image from 'components/ui/Image';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './ImageText.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IImageTextFields } from 'types/contentful/generated';
import type { Document } from '@contentful/rich-text-types';
import type { RichTextConfig } from 'components/ui/ContentBlocks/RichText';

type Props = IImageTextFields & {
  textContent?: Document;
  inspectorProps?: InspectorPropsType;
};

const ImageText = ({
  blockId,
  position = 'Right',
  textContent,
  image,
  imageDescription: description,
  inspectorProps,
}: Props): JSX.Element => {
  const richTextConfig: RichTextConfig = {
    'heading-2': `pt-0`,
  };

  const imageDescription = image?.fields?.description;
  const imageTitle = image?.fields?.title;

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      {position === 'Left' && (
        <div
          className={styles.contentLeft}
          {...inspectorProps?.({ fieldId: 'text' })}
        >
          <RichText fields={textContent} config={richTextConfig} />
        </div>
      )}
      <div className={styles.image}>
        <div {...inspectorProps?.({ fieldId: 'image' })}>
          <Image
            // eslint-disable-next-line
            // @ts-ignore
            src={image?.fields?.file.url || image?.url}
            // eslint-disable-next-line
            // @ts-ignore
            alt={imageDescription || imageTitle || ''}
            contentful
            // eslint-disable-next-line
            // @ts-ignore
            width={image?.fields?.file.details.image?.width || image?.width}
            // eslint-disable-next-line
            // @ts-ignore
            height={image?.fields?.file.details.image?.height || image?.height}
          />
          {description && (
            <div className={styles.imageDescription}>
              <RichText fields={description} config={richTextConfig} />
            </div>
          )}
        </div>
      </div>
      {position === 'Right' && (
        <div
          className={styles.contentRight}
          {...inspectorProps?.({ fieldId: 'textContent' })}
        >
          <RichText fields={textContent} config={richTextConfig} />
        </div>
      )}
    </div>
  );
};

export default ImageText;
